<template>
  <div class="area-container">
    <el-card>
      <div slot="header" class="clearfix">
        <span>社区管理</span>
        <el-button type="primary" size="small" style="float: right;" @click="openAddDialog">
          新增社区
        </el-button>
      </div>
      <el-table v-loading="loading" :data="areaList" border style="width: 100%">
        <el-table-column prop="areaId" label="社区ID" align="center" />
        <el-table-column prop="areaName" label="社区名称" align="center" />
        <el-table-column prop="areaCode" label="社区编码" align="center" />
        <el-table-column prop="remark" label="备注" align="center" show-overflow-tooltip />
        <el-table-column prop="createTime" label="创建时间" align="center" :formatter="formatDateTime" />
        <el-table-column label="操作" align="center" width="180">
          <template slot-scope="scope">
            <el-button size="mini" @click="openEditDialog(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page.sync="page.current" :page-sizes="[10, 20, 30, 50]" :page-size="page.size"
        :total="page.total" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false">
      <el-form ref="areaForm" :model="areaForm" :rules="areaRules" label-width="80px">
        <el-form-item label="社区名称" prop="areaName">
          <el-input v-model="areaForm.areaName" placeholder="请输入社区名称" />
        </el-form-item>
        <el-form-item label="社区编码" prop="areaCode">
          <el-input v-model="areaForm.areaCode" placeholder="请输入社区编码" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="areaForm.remark" type="textarea" :rows="3" placeholder="请输入备注" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitArea">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listAreas, saveArea, updateArea, deleteArea } from '@/api/community/areaApi'
import { dateFormat, timeFormat } from '@/utils/dateUtil'

export default {
  name: 'AreaList',
  data() {
    return {
      loading: false,
      areaList: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '新增社区',
      areaForm: {
        areaId: '',
        areaName: '',
        areaCode: '',
        remark: ''
      },
      areaRules: {
        areaName: [
          { required: true, message: '请输入社区名称', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      listAreas({
        page: this.page.current,
        row: this.page.size
      }).then(res => {
        const data = res.data || {}
        this.areaList = data.areas || []
        this.page.total = data.total || 0
      }).catch(error => {
        this.$message.error(error.message || '获取社区列表失败')
      }).finally(() => {
        this.loading = false
      })
    },
    openAddDialog() {
      this.dialogTitle = '新增社区'
      this.areaForm = {
        areaId: '',
        areaName: '',
        areaCode: '',
        remark: ''
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.areaForm.clearValidate()
      })
    },
    openEditDialog(row) {
      this.dialogTitle = '编辑社区'
      this.areaForm = {
        areaId: row.areaId,
        areaName: row.areaName,
        areaCode: row.areaCode,
        remark: row.remark
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.areaForm.clearValidate()
      })
    },
    formatDateTime(row, column, cellValue) {
      if (!cellValue) {
        return '-'
      }
      return dateFormat(cellValue) + ' ' + timeFormat(cellValue)
    },
    submitArea() {
      this.$refs.areaForm.validate(valid => {
        if (!valid) return
        const isEdit = !!this.areaForm.areaId
        const api = isEdit ? updateArea : saveArea
        api(this.areaForm).then(() => {
          this.$message.success(isEdit ? '编辑成功' : '新增成功')
          this.dialogVisible = false
          this.loadData()
        }).catch(error => {
          this.$message.error(error.message || '操作失败')
        })
      })
    },
    handleDelete(row) {
      this.$confirm('确认删除该社区？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteArea({ areaId: row.areaId }).then(() => {
          this.$message.success('删除成功')
          this.loadData()
        }).catch(error => {
          this.$message.error(error.message || '删除失败')
        })
      }).catch(() => {})
    },
    handleSizeChange(val) {
      this.page.size = val
      this.page.current = 1
      this.loadData()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.loadData()
    }
  }
}
</script>

<style lang="scss" scoped>
.area-container {
  padding: 20px;

  .el-card {
    margin-bottom: 20px;
  }

  .el-pagination {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
